import React, { PureComponent } from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import {getGuid} from '../helpers';

import { API, FAST_ANIMATION } from '../../../ws/constants';

class ClinicalHistoryModalBox extends PureComponent {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            clientId:this.props.clientId
            , fetchData:null
            , loading:false
            , isVisible:false
            , allergies:[{index:getGuid(), issue:""}]
            , medications:[{index:getGuid(), issue:""}]
            , otherProblems:[{index:getGuid(), issue:"", description:""}]
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount(){
        this.setState({loading:true});
        setTimeout(() => {
            this.setState({isVisible:true});
        }, FAST_ANIMATION);
        fetch(API + "getclientclinicalhistory&getbyid="+this.props.clientId)
        .then(response => response.json())
        .then(result => {
            let allergies = [...this.state.allergies]
                , medications = [...this.state.medications]
                , otherProblems = [...this.state.otherProblems];

            for(let i=0,n=result.data.length;i<n;i++){
                if(result.data[i].Type==="2") {
                    if(medications[0].issue==="")
                        medications = [];
                    medications.push({index: getGuid(), issue:result.data[i].Issue});
                } else if(result.data[i].Type==="3") {
                    if(otherProblems[0].issueOpt==="0")
                        otherProblems = [];
                    otherProblems.push({index: getGuid(), issue:result.data[i].Issue, issueOpt:result.data[i].IssueOpt, description:result.data[i].Description});
                } else {
                    if(allergies[0].issue==="")
                        allergies = [];
                    allergies.push({index: getGuid(), issue:result.data[i].Issue});
                }
            }

            this.setState({ allergies, medications, otherProblems, loading:false });
        });
    }

    /* END React own Functions */

    /* START Handles */

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });

    handleOk = (e) => {
        let DEFAULT_QUERY = "saveclientclinicalhistory&clientid=" + this.state.clientId + "&allergies=" + JSON.stringify(this.state.allergies)
                            + "&medications=" + JSON.stringify(this.state.medications) + "&otherproblems=" + JSON.stringify(this.state.otherProblems)
                            + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

        this.setState({loading:true});
        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(result => {
            this.setState({loading:false, isVisible:false});
            setTimeout(() => {
                this.props.modalCallBack(result, false);
            }, FAST_ANIMATION);
        });
    }

    handleCancel = (e) => {
        this.setState({isVisible:false});
        setTimeout(() => {
            this.props.modalCallBack(false, false); // 1st param should be the result whilst the second should be (keepModalOpen)
        }, FAST_ANIMATION);
    }

    handleClear = () => {
        //asda
    }

    handleAllergyChange = (e) => {
        let newArray = this.state.allergies.slice()
            , thisGuid = e.target.id.substring(e.target.id.indexOf("_")+1, e.target.id.length);
        for(let i=0,n=newArray.length;i<n;i++){
            if(newArray[i].index === thisGuid){
                newArray[i].issue = e.target.value.toString();
                break;
            }
        }
        this.setState({allergies:newArray});
    };
    handleMedicationChange = (e) => {
        let newArray = this.state.medications.slice()
            , thisGuid = e.target.id.substring(e.target.id.indexOf("_")+1, e.target.id.length);
        for(let i=0,n=newArray.length;i<n;i++){
            if(newArray[i].index === thisGuid){
                newArray[i].issue = e.target.value.toString();
                break;
            }
        }
        this.setState({medications:newArray});
    };
    handleOtherProblemsChange = (el, e) => {
        let newArray = this.state.otherProblems.slice();

        for(let i=0,n=newArray.length;i<n;i++){
            if(newArray[i].index === el){
                newArray[i].issueOpt = e.target.value.toString();
                newArray[i].issue = e.target.innerText;
                break;
            }
        }
        this.setState({otherProblems:newArray});
    }
    handleOtherProblemsDescriptionChange = (e) => {
        let newArray = this.state.otherProblems.slice()
            , thisGuid = e.target.id.substring(e.target.id.indexOf("_")+1, e.target.id.length);
        for(let i=0,n=newArray.length;i<n;i++){
            if(newArray[i].index === thisGuid){
                newArray[i].description = e.target.value.toString();
                break;
            }
        }
        this.setState({otherProblems:newArray});
    };
    handleAddMoreAllergies = (e) => {
        let allergies = [...this.state.allergies]
            , thisGuid = e.target.id.substring(e.target.id.indexOf("_")+1, e.target.id.length)
            , thisIndex = parseInt(e.target.dataset.thisindex, 10);

        if(typeof allergies[thisIndex] !== "undefined" && allergies[thisIndex].issue !== "" && allergies.length <= (thisIndex+1)){ //Add new
            var guid = getGuid();
            allergies.push({index:guid, issue:""});
        }else{
            for(let i=0,n=allergies.length;i<n;i++){
                if(allergies[i].index === thisGuid){
                    allergies.splice(i, 1);
                    break;
                }
            }
        }
        this.setState({ allergies });
    }

    handleAddMoreMedications = (e) => {
        let medications = [...this.state.medications]
            , thisGuid = e.target.id.substring(e.target.id.indexOf("_")+1, e.target.id.length)
            , thisIndex = parseInt(e.target.dataset.thisindex, 10);

        if(typeof medications[thisIndex] !== "undefined" && medications[thisIndex].issue !== "" && medications.length <= (thisIndex+1)){ //Add new
            var guid = getGuid();
            medications.push({index:guid, issue:""});
        }else{
            for(let i=0,n=medications.length;i<n;i++){
                if(medications[i].index === thisGuid){
                    medications.splice(i, 1);
                    break;
                }
            }
        }
        this.setState({ medications });
    }

    handleAddMoreProblems = (e) => {
        let otherProblems = [...this.state.otherProblems]
            , thisGuid = e.target.id.substring(e.target.id.indexOf("_") + 1, e.target.id.length)
            , thisIndex = parseInt(e.target.dataset.thisindex, 10);

        if(typeof otherProblems[thisIndex] !== "undefined" && otherProblems[thisIndex].issueOpt !== "0" && otherProblems.length <= (thisIndex+1)){ //Add new
            var guid = getGuid();
            otherProblems.push({index:guid, issue:"", description:""});
        }else{
            for(let i=0,n=otherProblems.length;i<n;i++){
                if(otherProblems[i].index === thisGuid){
                    otherProblems.splice(i, 1);
                    break;
                }
            }
            
        }
        this.setState({otherProblems});
    }

    /* END Handles */

    /* START Renders */

    render() {
        const { editable } = this.props;
        const allergies = this.state.allergies !== null ? this.state.allergies : []
              , medications = this.state.medications !== null ? this.state.medications : []
              , otherProblems = this.state.otherProblems !== null ? this.state.otherProblems : []
              , activeClass = this.state.isVisible ? "active" : ""
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="clinicalHistoryModal" className="form" ref="modalForm">
                <div className={"modalBox addEditPage " + activeClass + loadingClass}>
                    <button type="button" className="simpleBtn closeModal" onClick={this.handleCancel}><i className="fa fa-times"></i></button>
                    <div className="row">
                        <div className="col-12"><h2>Historial Clínico </h2></div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            {allergies.map((allergy, index) => {
                                return(
                                <div className="row" key={allergy.index}>
                                    <div className="fieldHolder col-10">
                                        <TextField fullWidth={true}
                                                   type="text"
                                                   id={"allergy_"+allergy.index}
                                                   value={allergy.issue}
                                                   onChange={this.handleAllergyChange}
                                                   label="Alergia"
                                                   disabled={!editable}/>
                                    </div>
                                    {(index !== 0 || (index === 0 && allergy.issue !== "")) ?
                                    <div className="col-2 text-center noPadding">
                                        <Tooltip
                                            title={(allergy.issue!==""&&allergies.length <= (index+1) ? "Adicionar outra" : "Remover esta") + " linha de Alergias"}
                                            enterDelay={200}>
                                            <span><button type="button"
                                                    className="simpleBtn actionButton addRemoveRow"
                                                    onClick={this.handleAddMoreAllergies}
                                                    disabled={!editable}>
                                                    <i id={"allergyAddRemove_"+allergy.index} data-thisindex={index} className={"fa" + (allergy.issue!==""&&allergies.length <= (index+1) ? " fa-plus success" : " fa-minus danger")}></i></button></span>
                                        </Tooltip>
                                    </div>
                                    : ""
                                    }
                                </div>
                            )})}
                        </div>
                        <div className="col-md-6">
                            {medications.map((medication, index) => {
                                return(
                                <div className="row" key={medication.index}>
                                    <div className="fieldHolder col-10">
                                        <TextField fullWidth={true}
                                                   type="text"
                                                   id={"medication_"+medication.index}
                                                   value={medication.issue}
                                                   onChange={this.handleMedicationChange}
                                                   label="Medicação"
                                                   disabled={!editable}/>
                                    </div>
                                    {(index !== 0 || (index === 0 && medication.issue !== "")) &&
                                    <div className="col-2 text-center noPadding">
                                        <Tooltip
                                            title={(medication.issue !== "" && medications.length <= (index+1) ? "Adicionar outra" : "Remover esta") + " linha de Medicação"}
                                            enterDelay={200}>
                                            <span><button type="button"
                                                    className="simpleBtn actionButton addRemoveRow"
                                                    onClick={this.handleAddMoreMedications}
                                                    disabled={!editable}>
                                                    <i id={"medicationAddRemove_"+medication.index} data-thisindex={index} className={"fa" + (medication.issue!==""&&medications.length <= (index+1) ? " fa-plus success" : " fa-minus danger")}></i></button></span>
                                        </Tooltip>
                                    </div>
                                    }
                                </div>
                            )})}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {otherProblems.map((problem, index) => {
                                if(typeof problem.issueOpt === "undefined") problem.issueOpt = "0";

                                return(
                                <div className="row" key={problem.index}>
                                    <div className="fieldHolder required selectField col-md-5">
                                        <InputLabel shrink={true}>Outros Problemas</InputLabel>
                                        <Select fullWidth={true}
                                                     id={"otherProblems_"+problem.index}
                                                     value={problem.issueOpt}
                                                     onChange={this.handleOtherProblemsChange.bind(this, problem.index)}
                                                     disabled={!editable}
                                                     placeholder="Escolha"
                                                     data-empty-error-message="Este campo não pode estar vazio">
                                              <MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>
                                              <MenuItem value="1" key="1">{"Cancro < 5 anos"}</MenuItem>
                                              <MenuItem value="2" key="2">Problemas Respiratórios</MenuItem>
                                              <MenuItem value="3" key="3">Diabetes</MenuItem>
                                              <MenuItem value="4" key="4">Problemas Cardíacos</MenuItem>
                                              <MenuItem value="5" key="5">Problemas de tiróide</MenuItem>
                                              <MenuItem value="6" key="6">Outro</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="col-md-1 hidden-md-down"></div>
                                    <div className="fieldHolder col-10 col-md-5">
                                        <TextField fullWidth={true}
                                                   type="text"
                                                   id={"otherProblemsDescription_"+problem.index}
                                                   value={problem.description}
                                                   onChange={this.handleOtherProblemsDescriptionChange}
                                                   label="Outros Diagnósticos"
                                                   disabled={!editable || problem.issueOpt!=="6"}/>
                                    </div>
                                    {(index !== 0 || (index === 0 && problem.issueOpt !== "0")) &&
                                    <div className="col-2 col-md-1 text-center noPadding">
                                        <Tooltip
                                            title={(problem.issueOpt !== "0" && otherProblems.length <= (index+1) ? "Adicionar outra linha de Diagnóstico" : "Remover esta linha de Diagnóstico")}
                                            enterDelay={200}>
                                            <span><button type="button"
                                                    className="simpleBtn actionButton addRemoveRow"
                                                    onClick={this.handleAddMoreProblems}
                                                    disabled={!editable}>
                                                    <i id={"problemAddRemove_"+problem.index} data-thisindex={index} className={"fa" + (problem.issueOpt !== "0" && otherProblems.length <= (index+1) ? " fa-plus success" : " fa-minus danger")}></i></button></span>
                                        </Tooltip>
                                    </div>
                                    }
                                </div>
                            )})}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder text-center">
                            <Button onClick={this.handleCancel} variant="contained" className="defaultButton float-left">Cancelar</Button>
                            {editable && <Button onClick={this.handleOk} className="button float-right" variant="contained" color="primary">Salvar</Button>}
                        </div>
                    </div>
                </div>
                <div className={"darkOverlay " + activeClass}></div>
            </div>
        );
    }
}

export default ClinicalHistoryModalBox;
